"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiddleWareCenter = exports.MiddleWareType = void 0;
var MiddleWareType;
(function (MiddleWareType) {
    /**
     * 处理Server推送消息中间件
     */
    MiddleWareType["RECEIVE_MESSAGE_FROM_SERVER"] = "RECEIVE_MESSAGE_FROM_SERVER";
})(MiddleWareType || (MiddleWareType = {}));
exports.MiddleWareType = MiddleWareType;
var MiddleWareCenter = /** @class */ (function () {
    function MiddleWareCenter() {
        this.middleWares = new Map();
    }
    /**
     * 插入指定类型的中间件
     *
     * @param {MiddleWareType} type
     * @param {MiddleWare} middleWare
     * @returns
     */
    MiddleWareCenter.prototype.useMiddleWare = function (type, middleWare) {
        if (!type || !middleWare) {
            return;
        }
        var middleWares = this.getMiddleWares(type);
        middleWares.push(middleWare);
        this.middleWares.set(type, middleWares);
    };
    /**
         * 执行某种类型的中间件
         *
         * @param {MiddleWareType} type
         * @param {IServerMessage} context
         */
    MiddleWareCenter.prototype.run = function (type, context) {
        var middleWares = this.getMiddleWares(type);
        this.compose(middleWares, context);
    };
    MiddleWareCenter.prototype.getMiddleWares = function (type) {
        var _a;
        return (_a = this.middleWares.get(type)) !== null && _a !== void 0 ? _a : [];
    };
    MiddleWareCenter.prototype.compose = function (middleWares, context) {
        var index = -1;
        function next(i) {
            if (i <= index)
                throw new Error('next only called once');
            index = i;
            if (i === middleWares.length)
                return context;
            var fn = middleWares[i];
            return fn === null || fn === void 0 ? void 0 : fn(context, next.bind(null, i + 1));
        }
        return next(0);
    };
    return MiddleWareCenter;
}());
exports.MiddleWareCenter = MiddleWareCenter;
